import * as React from "react"
import type { SVGProps } from "react"
const SvgMailbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 10.71H4v10h16v-10h-9a1 1 0 0 1-.71-.28A1 1 0 0 1 10 9.7q0-.42.29-.7a1 1 0 0 1 .71-.3h9q.83 0 1.41.6.6.57.59 1.4v10q0 .82-.59 1.42a2 2 0 0 1-1.41.58H4q-.82 0-1.41-.58A2 2 0 0 1 2 20.7v-10q0-.83.59-1.4A2 2 0 0 1 4 8.7h2v-5q0-.43.29-.7A1 1 0 0 1 7 2.7h6q.42 0 .71.3.3.27.29.7v2q0 .43-.29.72a1 1 0 0 1-.71.28H8v7q0 .43-.29.72a1 1 0 0 1-.71.28 1 1 0 0 1-.71-.28A1 1 0 0 1 6 13.7z" />
  </svg>
)
export default SvgMailbox
